/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {Link} from 'react-router-dom';
import {useStore} from '../../../../store/store';
import Card from '../../../shared/Card';
import PageWrapper from '../../../modules/PageWrapper';
import Finances from '../../../widgets/Finances';
import {formatNumber, formatNumber2} from '../../../functions/formatNumber';
import imagePlug from '../../../../_metronic/assets/media/user.png';

const safeNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const addThousands = (value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const normalizeNumericString = (value) => {
  if (value === null || value === undefined) return '0';

  let normalizedValue = String(value).trim();
  normalizedValue = normalizedValue.replace(/\s+/g, '').replace(/[^0-9.,-]/g, '');

  if (normalizedValue.includes(',') && normalizedValue.includes('.')) {
    normalizedValue = normalizedValue.replace(/,/g, '');
  } else {
    normalizedValue = normalizedValue.replace(',', '.');
  }

  if (normalizedValue === '' || normalizedValue === '-') return '0';

  return normalizedValue;
};

const formatMoneyTruncate = (value) => {
  let normalizedValue = normalizeNumericString(value);
  const isNegative = normalizedValue.startsWith('-');

  if (isNegative) normalizedValue = normalizedValue.slice(1);

  let [integerPart, fractionPart = ''] = normalizedValue.split('.');
  integerPart = integerPart.replace(/^0+(?=\d)/, '');
  fractionPart = fractionPart.slice(0, 2).padEnd(2, '0');

  return `${isNegative ? '-' : ''}${addThousands(integerPart === '' ? '0' : integerPart)}.${fractionPart}$`;
};

const formatMoneyNoDecimals = (value) => {
  let normalizedValue = normalizeNumericString(value);
  const isNegative = normalizedValue.startsWith('-');

  if (isNegative) normalizedValue = normalizedValue.slice(1);

  let integerPart = normalizedValue.split('.')[0];
  integerPart = integerPart.replace(/^0+(?=\d)/, '');

  return `${isNegative ? '-' : ''}${addThousands(integerPart === '' ? '0' : integerPart)}$`;
};

const getWorkspaceAvatar = (workspace) => {
  const avatar = workspace?.avatar || workspace?.logo || workspace?.image;

  return avatar ? `${process.env.REACT_APP_API_HOST}/${avatar}` : imagePlug;
};

const getLtcStatus = (ltcCategories, ltc) => {
  const ltcValue = safeNumber(ltc);
  const category = ltcCategories.find((item) => {
    return ltcValue >= safeNumber(item.ltc_min) && ltcValue < safeNumber(item.ltc_max);
  });

  return category?.indicator || 'secondary';
};

const getRdStatus = (rdCategories, averageCheck) => {
  const averageCheckValue = safeNumber(averageCheck);
  const category = rdCategories.find((item) => {
    return averageCheckValue >= safeNumber(item.rd_min) && averageCheckValue <= safeNumber(item.rd_max);
  });

  return category?.indicator || 'secondary';
};

const DashboardStatCard = ({type, stats}) => {
  const isLtc = type === 'ltc';

  return (
    <Finances
      background={isLtc ? 'bg_ltc_manager' : 'bg_rd_manager'}
      title={isLtc ? 'Статистика LTC' : 'Статистика RD'}
      subTitle='Управляйте периодом в календаре.'
      stats={
        isLtc
          ? [
              {
                title: 'Чаты',
                number: formatNumber(stats?.chats_count) || 0,
                icon: (
                  <i className='ki-duotone ki-fingerprint-scanning fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                    <span className='path5'></span>
                  </i>
                ),
              },
              {
                title: 'Регистрации',
                number: formatNumber(stats?.registrations_count) || 0,
                icon: (
                  <i className='ki-duotone ki-user-edit fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
              {
                title: 'Квалификации',
                number: formatNumber(stats?.qualifications_count) || 0,
                icon: (
                  <i className='ki-duotone ki-user-tick fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
              {
                title: 'LTC',
                number: `${formatNumber2(stats?.chat_to_qualification)}%`,
                icon: (
                  <i className='ki-duotone ki-wallet fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                  </i>
                ),
              },
            ]
          : [
              {
                title: 'Квалификации',
                number: formatNumber(stats?.qualifications_count) || 0,
                icon: (
                  <i className='ki-duotone ki-fingerprint-scanning fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                    <span className='path5'></span>
                  </i>
                ),
              },
              {
                title: 'Депозиты',
                number: formatNumber(stats?.deposits_count) || 0,
                icon: (
                  <i className='ki-duotone ki-wallet fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                  </i>
                ),
              },
              {
                title: 'Сумма депозитов',
                number: formatMoneyNoDecimals(stats?.deposits_amount),
                icon: (
                  <i className='ki-duotone ki-dollar fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
              {
                title: 'Средний чек',
                number: formatMoneyTruncate(stats?.players_avg_amount),
                icon: (
                  <i className='ki-duotone ki-user-tick fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
            ]
      }
    />
  );
};

const ManagerMetricRow = ({title, value, icon, isLast = false}) => (
  <div
    className={`d-flex align-items-center justify-content-between py-4 ${
      isLast ? '' : 'border-bottom border-gray-200'
    }`}
  >
    <div className='d-flex align-items-center'>
      <i className={`ki-duotone ${icon} fs-2 text-gray-400 me-3`}>
        <span className='path1'></span>
        <span className='path2'></span>
        <span className='path3'></span>
      </i>
      <span className='text-gray-500 fw-semibold fs-6'>{title}</span>
    </div>
    <span className='text-gray-700 fw-bold fs-6'>{formatNumber(value)}</span>
  </div>
);

const ManagersVisualCard = ({summary}) => {
  const verifiedManagers = safeNumber(summary.managers) - safeNumber(summary.trainees);
  const activeVerifiedManagers =
    safeNumber(summary.activeManagers) - safeNumber(summary.activeTrainees);

  return (
    <Card className='card h-100'>
      <div className='card-header border-0 pt-10 px-10 pb-0'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-2 text-gray-900 mb-1'>Менеджеры</span>
        </h3>
      </div>

      <div className='card-body px-10 pt-7 pb-8'>
        <ManagerMetricRow title='Тотал' value={summary.managers} icon='ki-profile-circle' />
        <ManagerMetricRow title='Верифицированные' value={verifiedManagers} icon='ki-verify' />
        <ManagerMetricRow title='Без верификации' value={summary.trainees} icon='ki-user' />

        <div className='text-gray-900 fw-bold fs-5 mt-7 mb-1'>Активные</div>
        <ManagerMetricRow title='Тотал' value={summary.activeManagers} icon='ki-timer' />
        <ManagerMetricRow
          title='Верифицированные'
          value={activeVerifiedManagers}
          icon='ki-verify'
        />
        <ManagerMetricRow
          title='Без верификации'
          value={summary.activeTrainees}
          icon='ki-user'
          isLast={true}
        />
      </div>
    </Card>
  );
};

const WorkforceCell = ({total, trainees}) => (
  <div className='d-flex align-items-center gap-2'>
    <span
      className='text-gray-900 fw-bold text-hover-primary fs-6 d-flex align-items-center gap-1'
      title='Верифицированные'
    >
      <i className='ki-duotone ki-verify fs-5 text-primary'>
        <span className='path1'></span>
        <span className='path2'></span>
      </i>
      {formatNumber(safeNumber(total) - safeNumber(trainees))}
    </span>
    <span
      className='text-gray-500 fw-bold fs-6 d-flex align-items-center gap-1'
      title='Без верификации'
    >
      <i className='ki-duotone ki-verify fs-5 text-gray-500'>
        <span className='path1'></span>
        <span className='path2'></span>
      </i>
      {formatNumber(trainees)}
    </span>
  </div>
);

const SalesWorkspaces = ({workspaces, ltcCategories, rdCategories}) => {
  return (
    <Card className='card mb-0'>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Воркспейсы</span>
        </h3>
      </div>

      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                <th className='ps-4 min-w-260px rounded-start'>Workspace</th>
                <th className='min-w-140px'>Менеджеры</th>
                <th className='min-w-140px'>Активные</th>
                <th className='min-w-110px'>Чаты</th>
                <th className='min-w-140px text-center'>Квалификации</th>
                <th className='min-w-160px text-center'>Сумма депозитов</th>
                <th className='min-w-110px text-center'>LTC</th>
                <th className='min-w-130px text-center'>Средний чек</th>
                <th className='min-w-80px text-end rounded-end'></th>
              </tr>
            </thead>

            <tbody>
              {!workspaces.length && (
                <tr>
                  <td className='text-muted fw-semibold py-8 text-center' colSpan={9}>
                    Активные воркспейсы не найдены
                  </td>
                </tr>
              )}

              {workspaces.map(({workspace, statistics}) => {
                const ltcStatus = getLtcStatus(ltcCategories, statistics?.ltc);
                const rdStatus = getRdStatus(rdCategories, statistics?.average_deposit);

                return (
                  <tr key={workspace.id}>
                    <td className='ps-4'>
                      <div className='d-flex align-items-center'>
                        <div className='symbol symbol-45px me-5'>
                          <img src={getWorkspaceAvatar(workspace)} alt='' />
                        </div>

                        <div className='d-flex justify-content-start flex-column'>
                          <span className='text-gray-900 fw-bold text-hover-primary mb-1 fs-6'>
                            {workspace.name}
                          </span>
                          <span className='text-muted fw-semibold text-muted d-block fs-7'>
                            #{workspace.id}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td>
                      <WorkforceCell
                        total={statistics?.users_count}
                        trainees={statistics?.trainees_count}
                      />
                    </td>

                    <td>
                      <WorkforceCell
                        total={statistics?.active_users_count}
                        trainees={statistics?.active_trainees_count}
                      />
                    </td>

                    <td>
                      <span className='text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6'>
                        {formatNumber(statistics?.chats_count)}
                      </span>
                    </td>

                    <td className='text-center'>
                      <span className='text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6'>
                        {formatNumber(statistics?.qualifications_count)}
                      </span>
                    </td>

                    <td className='text-center'>
                      <span className='text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6'>
                        {formatMoneyNoDecimals(statistics?.deposits_amount)}
                      </span>
                    </td>

                    <td className='text-center'>
                      <span className={`badge badge-light-${ltcStatus} fs-7 fw-bold`}>
                        {formatNumber2(statistics?.ltc)}%
                      </span>
                    </td>

                    <td className='text-center'>
                      <span className={`badge badge-light-${rdStatus} fs-7 fw-bold`}>
                        {formatMoneyTruncate(statistics?.average_deposit)}
                      </span>
                    </td>

                    <td className='text-end'>
                      <Link to={`/sales/workspaces/${workspace.id}`}>
                        <span className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                          <i className='ki-duotone ki-arrow-right fs-2'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                          </i>
                        </span>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </Card>
  );
};

const DashboardPage = observer(({timeConfig, isVerify, setPreloader}) => {
  const store = useStore();
  const [ltcStats, setLtcStats] = useState({});
  const [rdStats, setRdStats] = useState({});
  const [workspaces, setWorkspaces] = useState([]);
  const [ltcCategories, setLtcCategories] = useState([]);
  const [rdCategories, setRdCategories] = useState([]);
  const [managersSummary, setManagersSummary] = useState({
    managers: 0,
    trainees: 0,
    activeManagers: 0,
    activeTrainees: 0,
  });

  useEffect(() => {
    if (isVerify && timeConfig.time_config) {
      getData();
    }
  }, [isVerify, timeConfig]);

  const getData = async () => {
    try {
      const [
        getLtcStats,
        getRdStats,
        getWorkspaces,
        getLtcCategories,
        getRdCategories,
        getManagers,
      ] =
        await Promise.all([
          store.requestGet('user/sales/ltc/statistics', {params: timeConfig}, true),
          store.requestGet('user/sales/rd/statistics', {params: timeConfig}, true),
          store.requestGet(
            'user/sales/workspaces/statistics',
            {params: {...timeConfig, active: 1}},
            true
          ),
          store.requestGet('Finance/Category/getLtcList'),
          store.requestGet('Finance/Category/getRdList'),
          store.requestGet('user/sales/managers', {}, true),
        ]);

      const workspaceRows = (getWorkspaces || []).map(({statistics, ...workspace}) => {
        return {workspace, statistics: statistics || {}};
      });

      setLtcStats(getLtcStats || {});
      setRdStats(getRdStats || {});
      setWorkspaces(
        workspaceRows.sort((a, b) => {
          return safeNumber(b.statistics?.users_count) - safeNumber(a.statistics?.users_count);
        })
      );
      setLtcCategories(getLtcCategories || []);
      setRdCategories(getRdCategories || []);
      const activeTrainees = (getManagers?.managers || []).filter((manager) => {
        return manager?.is_traffic && manager?.is_trainee;
      }).length;

      setManagersSummary({
        managers: safeNumber(getManagers?.total?.managers_count),
        trainees: safeNumber(getManagers?.total?.trainees_count),
        activeManagers: safeNumber(getManagers?.total?.active_managers_count),
        activeTrainees,
      });
    } finally {
      setPreloader(false);
    }
  };

  return (
    <div className='row g-5 g-xl-10 mt-0'>
      <div className='col-xl-4 mb-5 mb-xl-10 mt-0'>
        <DashboardStatCard type='ltc' stats={ltcStats} />
      </div>

      <div className='col-xl-4 mb-5 mb-xl-10 mt-0'>
        <DashboardStatCard type='rd' stats={rdStats} />
      </div>

      <div className='col-xl-4 mb-5 mb-xl-10 mt-0'>
        <ManagersVisualCard summary={managersSummary} />
      </div>

      <div className='col-xl-12 mb-10 mt-0'>
        <SalesWorkspaces
          workspaces={workspaces}
          ltcCategories={ltcCategories}
          rdCategories={rdCategories}
        />
      </div>
    </div>
  );
});

const SalesPanel = () => {
  return (
    <PageWrapper
      firstTimeConfig='current_week'
      mode='sales'
      breadcrumbs={[
        {title: 'Panely', path: ''},
        {isSeparator: true},
        {title: 'Панель', path: '/dashboard/sales', isActive: true},
      ]}
      title='Панель'
    >
      <DashboardPage />
    </PageWrapper>
  );
};

export default SalesPanel;
